module.exports = __webpack_public_path__ + "static/media/bar-code.11416bac.svg";